import DataLayer, { ActionField, Product } from 'types/DataLayer';

export type WindowWithDataLayer = Window & {
  dataLayer: DataLayer;
  subriteAnalytics: any;
};

declare const window: WindowWithDataLayer;

export const trackSubrite = (url: string, initialPageView: boolean) => {
  if (typeof window.subriteAnalytics !== 'undefined' && !initialPageView) {
    window.subriteAnalytics.pageview(); // Do not track on first pageview. This is done by the script
  }
};

export const trackDatalayer = (url: string, initialPageView: boolean) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pageView',
    page: url,
    initialPageView,
  });
};

// export const trackEvent = (event: string, data: Record<string, unknown>) => {};

type PurchaseProps = {
  actionField: ActionField;
  products: Product[];
  reference?: string;
  introPrice?: number;
  recurringPrice?: number;
};

export const trackPurchase = (data: PurchaseProps) => {
  window.dataLayer = window.dataLayer || [];
  // We push empty ecommerce based on Google recommendation. https://developers.google.com/analytics/devguides/collection/ua/gtm/enhanced-ecommerce#purchases
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'purchase',
    reference: data.reference,
    ecommerce: {
      purchase: {
        actionField: data.actionField,
        products: data.products,
      },
    },
  });

  if (typeof window.subriteAnalytics !== 'undefined') {
    window.subriteAnalytics.convert({
      reference: data.reference,
      productPackageName: data.actionField.name,
      introPrice: data.introPrice,
      recurringPrice: data.recurringPrice,
      products: data.products,
    });
  }
};
